export const WAREHOUSE_SIZES = [
  {
    value: 'SMALL',
    label: 'Small',
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
  },
  {
    value: 'LARGE',
    label: 'Large',
  },
];

export const WAREHOUSE_STATES = {
  LCR_WH_RUNNING: {
    key: 'LCR_WH_RUNNING',
    label: 'Running',
    color: 'success',
  },
  LCR_WH_SUSPENDED: {
    key: 'LCR_WH_SUSPENDED',
    label: 'Suspended',
    color: 'warning',
  },
  LCR_WH_RESUMING: {
    key: 'LCR_WH_RESUMING',
    label: 'Resuming',
    color: 'info',
  },
  LCR_WH_PENDING: {
    key: 'LCR_WH_PENDING',
    label: 'Pending',
    color: 'default',
  },
  LCR_WH_FAILED: {
    key: 'LCR_WH_FAILED',
    label: 'Failed',
    color: 'error',
  },
  LCR_WH_TERMINATING: {
    key: 'LCR_WH_TERMINATING',
    label: 'Terminating',
    color: 'default',
  },
};


export const QUERY_STATUS = {
  QUEUED: 'QUEUED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};
